<template>
  <div class="user-info-wrap">
    <div class="user-info-line">
      <div  v-if="user.registered">用户<span class="user-name text-ellipsis">{{user.userName}}</span>({{getUserMemDesc(user.maxtMemberAuth)}})</div>
      <div v-else>&nbsp;</div>
      <div>
        <van-popover
            :show="true"
            :actions="[{'text':`分享注册领3天会员`}]"
            actions-direction="horizontal"
        >
          <template #reference>
            <ClipbordComponent type="danger" :show-copy-button="true" :show-content="false" notifyText="复制成功,马上邀请好友" btn-text="分享领会员" :text="shareUrl" />
          </template>
        </van-popover>
        &nbsp;
        <ClipbordComponent :show-content="false" btn-text="加入QQ群" :text="qqGroup" show-copy-button="true"/>
      </div>
    </div>
    <template  v-if="user.registered">
      <div v-if="authExpired" class="user-info-line van-color-warning">
        <div>会员已到期, 请充值或分享</div>
        <div>
          <router-link to="/pay">
            &nbsp;<van-button size="small" type="danger">充值</van-button>
          </router-link>
        </div>
      </div>
      <div v-else class="user-info-line">
        <div>授权有效期:<span class="user-auth">{{user.dataAuthTime}}</span></div>
        <div>
          <router-link to="/pay">
            <van-button size="small" type="danger">充值</van-button>
          </router-link>
        </div>
      </div>
<!--      <ShareNotice v-if="authExpired" :share-url="shareUrl" :show-dialog="authExpired"/>-->
    </template>
    <div v-if="user.registered && needUpdateAppVersion()" class="user-info-line van-color-warning">
      <div>当前软件版本需要更新</div>
      <div>
        <a :href="downloadUrl" target="_blank">
          &nbsp;<van-button size="small" type="primary">下载</van-button>
        </a>
      </div>
    </div>

  </div>
</template>
<style lang="less">
@import '@/app.less';

.user-info-wrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 1rem 1rem;
    flex-direction: row;
    background: #fafafa;
    //p{
    //    display: flex;
    //    align-items: center;
    //    justify-content: center;
    //}
}
.user-info-line{
  color: #28272C;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.2rem 0;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  width: 100%;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  font-size: 12px;
}

.text-ellipsis {
  white-space: nowrap;        /* 确保所有文本都在同一行 */
  overflow: hidden;           /* 隐藏超出容器的内容 */
  text-overflow: ellipsis;    /* 使用省略号表示文本溢出部分 */
}

.user-name{
    font-weight: bold;
    color: #000000;
    padding: 0.3em 0.3em 0.3em;
    font-size: 1.1em;
    max-width: 4rem;
    display: inline-flex;
}
.user-auth{
    color: #000000;
    padding-left: 0.3rem;
}

.van-color-warning{
  color: @color2;
}

</style>
<script>
import store from "@/store";
import { format } from 'date-fns';
import {onMounted, ref, watch} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import app from "@/App.vue";
import {useRouter} from "vue-router";
import ShareNotice from "@/components/ShareNotice.vue";

const memTypeDescMap = {
  "Bronze":"青铜",
  "Silver":"白银",
  "Gold":"黄金",
  "Platinum":"铂金",
  "Diamond":"钻石",
  "Honor":"星耀",
  "King":"王者",
  "Empire":"皇帝",
};

const shareUrlMap = {
  "FamilyMember": "他趣家族助手, 浏览器打开下载: https://www.haoping.fun/?tab=family",
  "DataMember": "语音平台计件看盘数据, 浏览器打开下载:  https://www.haoping.fun/?tab=data",
  "DoumiMember": "抖音私域引流, 浏览器打开下载:https://www.haoping.fun/?tab=doumi",
};



export default {
  name: "UserInfo",
  computed: {
    app() {
      return app
    }
  },
    components: {ShareNotice, ClipbordComponent},
    setup(){
      const userStore = store.userStore();
      const appVersion = ref(userStore.getAppVersion());
      const dataAppNewVersion = "1.0.38";
      const familyAppNewVersion = "1.0.30";
      const newAppVersion = userStore.getBizType() === "DataMember" ? dataAppNewVersion : familyAppNewVersion;
      const qqGroup = ref("1031191163");
      const bizType = userStore.getBizType();

      const shareUrl = ref(bizType!=="FamilyMember"?"语音平台计件看盘数据, 浏览器打开下载:  https://www.haoping.fun/?tab=data":"他趣家族助手, 浏览器打开下载: https://www.haoping.fun/?tab=family");
      const downloadUrl = ref(bizType!=="FamilyMember"?"https://oss.haoping.fun/dacal-v1.0.1.apk":"https://www.haoping.fun/download/family-v1.0.11.apk");

      const expired = ref(userStore.user.dataAuthTime < format(new Date(), 'yyyy-MM-dd H:mm:ss'));

      const state = ref({
          user: userStore.user,
          authExpired: expired,
          appVersion,
          qqGroup,
          newAppVersion,
          shareUrl,
          downloadUrl,
        /**
         *
         * @param memAuth {{memberType:string, expire: string}}
         * @returns {*|string|string}
         */
          getUserMemDesc(memAuth){
            if(!memAuth){
              return expired.value ? "黑铁" : "青铜";
            }
            return memTypeDescMap[memAuth.memberType] ||(expired.value ? "黑铁" : "青铜");
          }
      });

        const router = useRouter();
        const current = router.currentRoute.value;
        const routeTo = (path) => router.push(path);

        onMounted(async () => {
            const deviceId = userStore.getDeviceId();

            if(!deviceId){
                return;
            }

            const data = await userStore.getUserInfo(deviceId);
            if(data.success){
                Object.assign(state.value.user,userStore.user);
                if(userStore.user.familyUser) {
                  userStore.saveBizType("FamilyMember");
                  qqGroup.value = "756040009";
                  shareUrl.value = "他趣家族助手, 浏览器打开下载: https://www.haoping.fun/?share_token=" + userStore.user.shareToken +"&tab=family"
                  downloadUrl.value = "https://www.haoping.fun/download/family-v1.0.11.apk";
                }else if(userStore.user.bizType === "dacal"){
                  userStore.saveBizType("DataMember");
                  qqGroup.value = "1031191163";
                  shareUrl.value = "语音平台计件看盘数据, 浏览器打开下载:  https://www.haoping.fun/?share_token=" + userStore.user.shareToken +"&tab=data"
                  downloadUrl.value = "https://oss.haoping.fun/dacal-v1.0.1.apk";
                }else{
                  userStore.saveBizType("DataMember");
                  qqGroup.value = "1031191163";
                  shareUrl.value = "语音平台计件看盘数据, 浏览器打开下载:  https://www.haoping.fun/?share_token=" + userStore.user.shareToken +"&tab=data"
                  downloadUrl.value = "https://oss.haoping.fun/dacal-v1.0.1.apk";
                  // userStore.saveBizType("DoumiMember");
                  // qqGroup.value = "865758669";
                  // shareUrl.value = "抖音私域引流:  https://www.haoping.fun/?share_token=" + userStore.user.shareToken +"&tab=doumi"
                  // downloadUrl.value = "https://www.haoping.fun/download/douxiaomi-v1.0.1.apk";
                }

                expired.value = userStore.user.dataAuthTime < format(new Date(), 'yyyy-MM-dd H:mm:ss');

                if(deviceId.startsWith("family") &&  (userStore.user.maxtMemberAuth === "Silver" || userStore.user.maxtMemberAuth === "Bronze")){
                  expired.value = false;
                }
            }
        });

        watch(userStore.user, async (value) => {
          expired.value = value.dataAuthTime < format(new Date(), 'yyyy-MM-dd H:mm:ss');
          if(expired.value && current.path !== '/pay'){
            routeTo("/pay");
          }
        });

        return state.value;
    },
  methods:{
    compareVersion(version1, version2) {

      if (!version1) {
        return -1;
      }

      if (!version2) {
        return -1;
      }

      const v1 = version1.split('.');
      const v2 = version2.split('.');
      const maxLength = Math.max(v1.length, v2.length);

      for (let i = 0; i < maxLength; i++) {
        // 如果版本号中没有该段，则默认为0
        const num1 = parseInt((v1[i] || '0').match(/^(\d+).*$/)[1], 10);
        const num2 = parseInt((v2[i] || '0').match(/^(\d+).*$/)[1], 10);

        // 比较每一段数字
        if (num1 > num2) return 1; // version1 > version2
        if (num1 < num2) return -1; // version1 < version2
      }

      // 所有段都相等
      return 0;
    },
    needUpdateAppVersion(){
      const appVersion = this.appVersion;

      if(!appVersion){
        return true;
      }

      const newAppVersion = this.newAppVersion;
      return this.compareVersion(appVersion, newAppVersion) < 0;
    }
  }
}
</script>
